angular.module('gym.membership-plans', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.membership-plans', {
    abstract: true,
    template: '<ui-view>',
    resolve: {
      membershipPlanCategories: ["gym", "$stateParams", function(gym, $stateParams) {
        return gym.membershipPlanCategories();
      }]
    }
  }).state('gym.membership-plans.list', {
    url: '/membership_plans',
    template: require('templates/gyms/membership_plans/list.html.slim')
  }).state('gym.membership-plans.archived-membership-plans', {
    url: '/membership_plans/archived_list',
    template: require('templates/gyms/membership_plans/archived_list.html.slim')
  }).state('gym.membership-plans.book_and_pay', {
    url: '/membership_plans/manage_book_and_pay',
    template: require('templates/gyms/membership_plans/manage_book_and_pay.html.slim')
  }).state('gym.membership-plans.new', {
    url: '/membership_plans/new?from',
    templateUrl: function($stateParams) {
      return `/gyms/${$stateParams.gymId}/membership_plans/new.template`;
    },
    controller: 'NewMembershipPlanCtrl',
    resolve: {
      fromPlan: ["$stateParams", "MembershipPlans", function($stateParams, MembershipPlans) {
        var id;
        id = $stateParams.from || 'new';
        return MembershipPlans.get(id);
      }],
      eventTypes: ["EventTypes", function(EventTypes) {
        return EventTypes.getList({
          count: 1000
        });
      }],
      gradingStyles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        });
      }]
    }
  }).state('gym.membership-plans.edit', {
    url: '/membership_plans/:membershipPlanId/edit',
    templateUrl: function($stateParams) {
      return `/gyms/${$stateParams.gymId}/membership_plans/${$stateParams.membershipPlanId}/edit.template`;
    },
    controller: 'ShowMembershipPlansCtrl',
    resolve: {
      membershipPlan: ["MembershipPlans", "$stateParams", function(MembershipPlans, $stateParams) {
        return MembershipPlans.get($stateParams.membershipPlanId);
      }],
      gradingStyles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        });
      }]
    }
  }).state('gym.membership-plans.show', {
    url: '/membership_plans/:membershipPlanId',
    template: require('templates/gyms/membership_plans/show.html.slim')
  }).state('gym.membership-plans.members', {
    url: '/membership_plans/:membershipPlanId/members',
    template: require('templates/gyms/membership_plans/members_list.html.slim')
  }).state('gym.membership-plans.non-attending-contacts', {
    url: '/membership_plans/:membershipPlanId/non_attending_contacts',
    template: require('templates/gyms/membership_plans/nac_list.html.slim')
  });
}]);
